/* eslint-disable @typescript-eslint/explicit-function-return-type */
import {
	ButtonLayout,
	ButtonLink,
	ButtonPrimary,
	Grid,
	IconWarningLight,
	Text2,
	Text3,
	Text1,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";
import React, { useCallback, useEffect } from "react";

import { strings } from "../../localization";
import { FeedbackContainer, ScreenResponsive } from "../../components";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { useAnalytics } from "../../hooks/useAnalytics";
import { useNavigateCustom } from "../../hooks";
import { StoreNameEnum } from "../../enum/storesEnum";

interface LocationState {
	timeoutBalance?: boolean;
	routeTryAgain?: string;
	code?: string;
	errorMessage?: string;
}

const { description, title } = strings.pages.systemUnavailable;
const { toGoOut, tryAgain } = strings.components.buttons;

const SystemUnavailable: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const location = useLocation();
	const state = location.state as LocationState;
	const { authenticationStore } = useGlobalStore();
	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent, updatePageView } = useAnalytics();

	useEffect(() => {
		updatePageView({ name: "Vivo Money FGTS Sistema Indisponível", pagePath: "/fgts/sistema-indisponivel" });
	}, []);

	// Efetua o logout na aplicação
	const onHandleToGoOut = useCallback(() => {
		addAnalyticEvent({ action: "click.button", step: "fgts:sistema-indisponível", description: toGoOut }, { applySanitize: true });
		authenticationStore.logout();
		navigation("/login", { replace: true });
	}, []);

	// Efetua o refetch da última requisição
	const onHandleTryAgain = useCallback(() => {
		addAnalyticEvent({ action: "click.button", step: "fgts:sistema-indisponível", description: tryAgain }, { applySanitize: true});

		if (state.routeTryAgain) {
			navigation(state.routeTryAgain);
			return;
		}

		const lastRoute = sessionStorage.getItem(StoreNameEnum.LAST_ROUTE);
		navigation(lastRoute || "/");
	}, [state]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<FeedbackContainer
					icon={<IconWarningLight size={64} color={skinVars.colors.controlError} />}
					title={title}
					description={state.code && state.errorMessage ?
						<>
							{state.errorMessage}
							<br />
							<Text1 regular >{state.code}</Text1>
						</>
						: description}
				>
					<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
						<ButtonPrimary onPress={onHandleTryAgain} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonPrimary}>
								{tryAgain}
							</Text3>
						</ButtonPrimary>

						<ButtonLink onPress={onHandleToGoOut} showSpinner={false} disabled={false}>
							<Text2 medium color={skinVars.colors.textLink}>
								{toGoOut}
							</Text2>
						</ButtonLink>
					</ButtonLayout>
				</FeedbackContainer>
			</Grid>
		</ScreenResponsive>
	);
});

export default SystemUnavailable;
